import type { TranslationCatalog } from "../TranslationManager";

export const pt: TranslationCatalog = {
  "labels.cardNumber": "Número do cartão",
  "labels.expirationDate": "Data de validade",
  "labels.cvc": "Código de segurança",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / AA",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "O número do seu cartão é inválido.",
  "errors.invalidExpiryDate": "A data de validade do seu cartão é inválida.",
  "errors.invalidCvc": "O código de segurança do seu cartão é inválido.",
  "errors.incompleteCardNumber": "O número do seu cartão está incompleto.",
  "errors.incompleteExpiryDate": "A data de validade do seu cartão está incompleta.",
  "errors.incompleteCvc": "O código de segurança do seu cartão está incompleto.",
  "errors.expiredCard": "O seu cartão expirou.",
  "aria.cardNumber": "Número do cartão",
  "aria.expirationDate": "Data de validade",
  "aria.cvc": "Código de segurança",
  "aria.cardInput": "Informações do cartão",
};
